export default __webpack_public_path__ + "static/media/chrome.0751f657.svg";